import type { DeeplinkActionMoveProperty } from '@bucketplace/owap-sdk';

/**
 * OWAP 웹뷰 관련 유틸리티 함수
 */
export type OwapWebviewType = DeeplinkActionMoveProperty['webviewType'];

/**
 * OWAP 앱 여부를 체크합니다.
 * sessionStorage의 'owapApp' 값을 확인하여 공통웹뷰와 구웹뷰를 구분합니다.
 */
export const isOwapApp = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return sessionStorage.getItem('owapApp') === 'true';
};

/**
 * OWAP 웹뷰 타입을 가져옵니다.
 */
export const getOwapWebviewType = (): OwapWebviewType | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return (sessionStorage.getItem('owapWebviewType') as OwapWebviewType) ?? null;
};

/**
 * 구웹뷰에서 공통웹뷰로 redirect 시, 기존 구웹뷰를 닫기 위한 쿼리 파라미터 키
 */
export const CLOSE_LEGACY_WEBVIEW_KEY = 'closeLegacyWebview';
